import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@patient-watch/ui";
import { AlertCircle, CheckCircle, ClipboardCheck, Users } from "lucide-react";
import { useCopy } from "../i18n/locale";

export const Route = createFileRoute("/get-started")({
    component: JoinComponent,
});

function JoinComponent() {
    const copy = useCopy().getStarted;
    return (
        <div className="mx-auto px-4 max-w-4xl">
            <div className="mb-12 text-center">
                <h1 className="mb-4 font-bold text-slate-800 text-4xl">{copy.title}</h1>
                <p className="mx-auto max-w-2xl text-slate-600 text-xl">{copy.subtitle}</p>
            </div>

            <div className="gap-8 grid md:grid-cols-2 mx-auto mb-8 max-w-4xl">
                <Card className="border-2 border-slate-200 hover:border-blue-300 transition-colors">
                    <CardHeader className="pb-4 text-center">
                        <div className="flex justify-center items-center bg-blue-100 mx-auto mb-4 rounded-full w-16 h-16">
                            <Users className="w-8 h-8 text-blue-600" />
                        </div>
                        <CardTitle className="text-slate-800 text-2xl">{copy.waitlistTitle}</CardTitle>
                        <CardDescription className="text-slate-600 text-lg">{copy.waitlistDescription}</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="space-y-3 mb-6 text-slate-600">
                            {copy.waitlistPoints.map((point) => (
                                <div key={point} className="flex items-start gap-3">
                                    <CheckCircle className="flex-shrink-0 mt-0.5 w-5 h-5 text-green-600" />
                                    <span>{point}</span>
                                </div>
                            ))}
                        </div>
                        <Link to="/waitlist">
                            <Button variant="default" className="py-6 w-full text-lg">
                                {copy.joinWaitlist}
                            </Button>
                        </Link>
                    </CardContent>
                </Card>

                <Card className="bg-green-50/30 border-2 border-green-200 hover:border-green-400 transition-colors">
                    <CardHeader className="pb-4 text-center">
                        <div className="flex justify-center items-center bg-green-100 mx-auto mb-4 rounded-full w-16 h-16">
                            <ClipboardCheck className="w-8 h-8 text-green-600" />
                        </div>
                        <CardTitle className="text-slate-800 text-2xl">{copy.studyTitle}</CardTitle>
                        <CardDescription className="text-slate-600 text-lg">{copy.studyDescription}</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="space-y-3 mb-6 text-slate-600">
                            {copy.studyPoints.map((point, index) => (
                                <div key={point} className="flex items-start gap-3">
                                    {index === 0 ? (
                                        <AlertCircle className="flex-shrink-0 mt-0.5 w-5 h-5 text-amber-600" />
                                    ) : (
                                        <CheckCircle className="flex-shrink-0 mt-0.5 w-5 h-5 text-green-600" />
                                    )}
                                    <span>{point}</span>
                                </div>
                            ))}
                        </div>
                        <Link to="/login">
                            <Button className="bg-green-600 hover:bg-green-700 py-6 w-full text-lg">
                                {copy.begin}
                            </Button>
                        </Link>
                    </CardContent>
                </Card>
            </div>
            <Button asChild variant="link">
                <Link to="/">{copy.backHome}</Link>
            </Button>
        </div>
    );
}
